export default {
  path: '/nickname',
  meta: {
    title: '修改昵称',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/nickname`),
}



// WEBPACK FOOTER //
// ./src/views/changeName/router.js